/* eslint-disable */
import React from 'react';
import { useHistory } from 'react-router-dom';
import './O2CDashboardSection.css';

const O2CDashboardSection = ({
  title,
  children,
  showDetailView = true,
  disableDetailView = false,
  detailPath,
  detailState = {} 
}) => {
  const history = useHistory();

  const handleDetailClick = () => {
    if (detailPath) {
      history.push(detailPath, detailState);
    }
  };

  return (
    <div className="dashboard-section-o2c">
      {/* <div className="dashboard-section-header"> */}
        {/* <h3>{title}</h3> */}
        {showDetailView && !disableDetailView && (
          <button
            className="detail-view-btn-o2c"
            onClick={handleDetailClick}
          >
            Detailed View <span className="arrow">»</span>
          </button>
        )}
      {/* </div> */}
      <div className="dashboard-section-body">
        {children}
      </div>
    </div>
  );
};

export default O2CDashboardSection;